import React, { useState, useContext } from "react";
import { Box, Typography } from "@material-ui/core";
import BreadCrumb from "../../layout/breadcrumbs/breadcrumbs";
import CustomPagination from "../../layout/pagination/pagination";
import TenderTable from "../../tenderTables/tenderTable";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { sentechDarkGrey } from "../../../theme/colors";
import axios from "axios";
import { endpoint } from "../../../endpoint/endpoints";
import { ApplicationContext } from "../../../context/ApplicationContext";
import { tenderErorr } from "../../../apiRequests/errorMessages";
import { useRef } from "react";

// styling
const useStyles = makeStyles(() =>
  createStyles({
    breadcrumbs: {
      display: "flex",
      justifyContent: "flex-end",
      paddingRight: "9.3%",
      paddingTop: "2.5%",
    },

    heading: {
      display: "flex",
      justifyContent: "center",
      paddingTop: "3%",
      color: sentechDarkGrey,
    },

    subheading: {
      display: "flex",
      justifyContent: "space-evenly",
      paddingTop: "3%",
      color: sentechDarkGrey,
    },

    table: {
      // paddingLeft: "4%",
      marginLeft: "7%",
      marginRight: "7%",
      display: "flex",
      justifyContent: "center",
      paddingTop: "2%",
      margin: "1%",
    },

    paginations: {
      display: "flex",
      justifyContent: "center",
      paddingTop: "2%",
      paddingBottom: "3%",
      paddingRight: "9.5%",
      color: sentechDarkGrey,
    },
  })
);

function ClosedTendersPage() {
  // material ui
  const classes = useStyles();

  const {
    setMessage,
    openSnackbar,
    setLoading,
    popOpenTenders,
    closedTenders,
    popClosedTenders,
    popCategories,
    setSeverity,
  } = useContext(ApplicationContext);

  const Categories = useRef([{ lablel: "test", id: "test" }]);
  const mounted = React.useRef(true);

  const handleOnPageLoad = async (event) => {
    if (mounted.current) {
      mounted.current = false;
      setLoading(true);
      try {
        const response = await axios.get(
          endpoint.LIST_CATEGORIES, //endpoint
          {
            headers: {
              "user-token": localStorage.getItem("user_token"),
              authorization: localStorage.getItem("authorization"),
            },
          }
        );
        if (response.status === 200) {
          if (response.data.error === false) {
            const data = response.data.message.categories;

            // console.log(data.map((category) => ({ label: category.name })));
            // setCategories(
            //   data.map((category) => ({
            //     label: category.name,
            //     id: category.category_id,
            //   }))
            // );
            const fetchedCat = data.map((category) => ({
              label: category.name,
              id: category.id,
            }));
            Categories.current = fetchedCat;
            popCategories(fetchedCat);
          }
        }
        // setLoading(false);
      } catch (error) {
        // setLoading(false);
      }
      // if (openTenders.length) {
      //   setLoading(false);
      //   return;
      // }

      try {
        const response = await axios.get(
          endpoint.LIST_MYTENDER_ENDPOINT, //endpoint
          {
            headers: {
              "user-token": localStorage.getItem("user_token"),
              authorization: localStorage.getItem("authorization"),
            },
          }
        );
        //   const response = apiResponse;
        if (response.status === 200) {
          if (response.data.error === false) {
            const data = response.data.message;
            const now = Math.floor(Date.now() / 1000);
            // data.forEach((element) => {
            //   if (element.tender_number) {
            //     if (element.close_datetime <= now) popClosedTenders([element]);
            //     else popOpenTenders([element]);
            //   }
            // });
            popClosedTenders(data.filter((itm) => itm.close_datetime <= now));
            popOpenTenders(data.filter((itm) => itm.close_datetime > now));
            setLoading(false);
          } else {
            setMessage(tenderErorr(response.data.errorcode));
            response.data.errorcode === 5
              ? setSeverity("info")
              : setSeverity("error");
            setLoading(false);
            openSnackbar();
          }
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    }
  };
  //page title seen on browser
  React.useEffect(() => {
    document.title = "Closed tenders";
  }, []);

  React.useEffect(() => {
    const refresh = setInterval(() =>
    handleOnPageLoad() 
    ,2820
    );
    return () => {
      clearInterval(refresh)
    };
  }, []);

  // tender table data
  const tableData = [
    {
      id: 1,
      tender_number: "SENT/007/2022-23",
      category: "Professional",
      tender_type: "Public",
      tender_description:
        "Framework agreemen for the appointment of service providers into a panel of forensic investigative services for a period of three years",
      issue_date: "28/06/22",
      briefing_session: "28/06/22 12:00:00",
      closing_date: "26/07/22 17:00:00",
    },
  ];

  const SCMTenders = closedTenders.filter((itm) => itm.role === "scm");
  const BSECTenders = closedTenders.filter((itm) => itm.role === "bsec");

  // function for pagination
  const perPage = 5;
  const maxSCMPage = Math.ceil(SCMTenders.length / perPage);
  const maxBSECPage = Math.ceil(BSECTenders.length / perPage);

  const [SCMpage, setSCMPage] = useState(1);
  const [BSECpage, setBSECPage] = useState(1);

  function onNewSCMPage(newPage) {
    setSCMPage(newPage);
  }

  function onNewBSECPage(newPage) {
    setBSECPage(newPage);
  }

  // function for empty tenders table
  function getTendersList() {
    if (closedTenders.length) {
      return (
        <>
          {getSCM()}
          {getBSEC()}
        </>
      );
    } else {
      return (
        <Box
          style={{
            color: sentechDarkGrey,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Typography>There are no Closed tenders.</Typography>
        </Box>
      );
    }
  }

  function getSCM() {
    if (localStorage.getItem("scmRole"))
      return (
        <>
          <Box className={classes.heading}>
            <Typography style={{ fontSize: "24px" }}>
              CLOSED TENDERS - SCM
            </Typography>
          </Box>

          {SCMTenders.length ? (
            <>
              <Box className={classes.table}>
                <TenderTable
                  tableData={SCMTenders}
                  page={SCMpage}
                  perPage={perPage}
                  useCase={"bsecClosedTendersList"}
                />{" "}
              </Box>
              <Box className={classes.paginations}>
                <CustomPagination onNewPage={onNewSCMPage} count={maxSCMPage} />
              </Box>
            </>
          ) : (
            <Box
              style={{
                color: sentechDarkGrey,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Typography>There are no Closed Tenders.</Typography>
            </Box>
          )}
        </>
      );
  }

  function getBSEC() {
    if (localStorage.getItem("bsecRole"))
      return (
        <>
          <Box className={classes.heading}>
            <Typography style={{ fontSize: "24px" }}>
              CLOSED TENDERS - BSEC
            </Typography>
          </Box>
          {BSECTenders.length ? (
            <>
              <Box className={classes.table}>
                <TenderTable
                  tableData={BSECTenders}
                  page={BSECpage}
                  perPage={perPage}
                  useCase={"bsecClosedTendersList"}
                />
              </Box>
              <Box className={classes.paginations}>
                <CustomPagination
                  onNewPage={onNewBSECPage}
                  count={maxBSECPage}
                />
              </Box>
            </>
          ) : (
            <Box
              style={{
                color: sentechDarkGrey,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Typography>
                You have not been assigned to any Closed Tenders.
              </Typography>
            </Box>
          )}
        </>
      );
  }

  return (
    <Box>
      <Box className={classes.breadcrumbs}>
        <BreadCrumb />
      </Box>
      {getSCM()}
      {getBSEC()}
    </Box>
  );
}

export default ClosedTendersPage;
